const palette = {
  LIGHT: {
    primary: {
      main: "#c1dfff",
      dark: "#90adcc",
      light: "#f4ffff"
    },
    fontColor: {
      main: "#040424"
    },
    secondary: {
      main: "#feffc1",
      dark: "#cacc90",
      light: "#fffff4"
    },
    error: {
      main: "#ff4542"
    },
    background: {
      default: "#fdf9f6",
      paperDefault: "#feffc1",
      iconDefault: "#873865",
      iconTab: "#873865",
      cardDefault: "#f5f9fa"
    }
  },
  DARK: {
    type: "dark",
    primary: {
      main: "#040424",
      dark: "#04DBFF",
      light: "#E70447"
    },
    fontColor: {
      main: "#DA0443"
    },
    secondary: {
      main: "#DA0443",
      dark: "#C0043B",
      light: "#E70447"
    },
    error: {
      main: "#C2043C"
    },
    background: {
      default: "#1B2033",
      paperDefault: "#551b3c",
      iconDefault: "#481e36",
      cardDefault: "#072b3a",
      iconTab: "#feffc1"
    }
  }
};

export default palette;
